import { NPrivacyState } from '@df/core/meta/privacy-state.service';
import { PrivacyService } from '@df/module-privacy/privacy.service';
PrivacyService.rules[NPrivacyState.Area.performance]?.add('_conv_s');
PrivacyService.rules[NPrivacyState.Area.performance]?.add('_conv_v');
PrivacyService.rules[NPrivacyState.Area.performance]?.add('_conv_r');
